import * as EmailValidator from "email-validator";

export function validateEmailAddress(email: string): boolean {
    /*
        Regex used to validate dynamic text objects i.e. {{Entry.Email}}. It checks that the
        string has opening '{{' and closing '}}' with any text in between
    */
    if (email.match("(({){2}([^]+)(}){2})")) {
        return true;
    }

    return EmailValidator.validate(email);
}
